import React, { useEffect, useState } from 'react'
import Layout from './layout'
import heroDesktopBanner from "../assets/images/ForContractorsBanner.jpg"
import heroMobileBanner from "../assets/images/ForContractorsBannerMobile.jpg"
import expertiseDesktopBanner from "../assets/images/WorkWithLuminicos.jpg"
import expertiseMobileBanner from "../assets/images/WorkWithLuminicosMobile.jpg"
import Logo from "../assets/images/luminicoslogo.svg"
import { Link, useParams } from 'react-router-dom'
import Ourclient from '../components/Ourclient'
import LimaHotel from "../assets/images/LimaHotel.jpg"
import ArchitectImage from '../assets/images/home-hero-banner.jpg';
import ContractorImage from '../assets/images/hotelLimaBanner.jpg';
import DeveloperImage from '../assets/images/multicolumn2.jpg';
import { CgArrowTopRight } from "react-icons/cg";
import multiColumn1 from "../assets/images/multicolumn1.jpg"
import multiColumn2 from "../assets/images/multicolumn2.jpg"
import ClientReviews from '../components/ClientReviews'
import { FaLightbulb, FaTools, FaCogs, FaHardHat } from "react-icons/fa";
import { IoShareSocialSharp } from "react-icons/io5";
import { TbStack2Filled } from "react-icons/tb";
import { TbArrowsLeftRight } from "react-icons/tb";
import { FaCheck } from "react-icons/fa";
import axios from 'axios'
import config from '../config'
import fcContent from '../JSONData/forContractors.json'
import { HeroBanner } from './LightingFacade'
const SingleService = () => {
    const [featuredProject, setFeaturedProject] = useState([])
    const [shareholder, setShareHolder] = useState([]);
    const { id, lang } = useParams();

    const content = (fcContent && fcContent[lang]) ? fcContent[lang] : fcContent.en;
    const [archContent, setArchContent] = useState(null)

    const getProjectUrl = (slug) => {
        return lang ? `/${lang}/project/${slug}` : `/project/${slug}`;
    };

    const offers = content.offers.map((o) => ({
        icon: o.icon === 'bulb' ? <FaLightbulb /> : o.icon === 'share' ? <IoShareSocialSharp /> : o.icon === 'tools' ? <FaTools /> : o.icon === 'stack' ? <TbStack2Filled /> : o.icon === 'cogs' ? <FaCogs /> : o.icon === 'hardhat' ? <FaHardHat /> : <TbArrowsLeftRight />,
        title: o.title,
        desc: o.desc
    }));

    const reasons = content.reasons;

    // const fetchFeaturedProjectDetails = async () => {
    //     try {
    //         const response = await axios.get(`${config.BASE_URL}/api/admin/get-featured-projects-chronological${lang ? `?lang=${lang}` : ''}`, { withCredentials: true });
    //         setFeaturedProject(response.data);
    //     } catch (err) {
    //         console.log('Failed to fetch project details');
    //     }
    // }
    const fetchShareHolderDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-shareholders${lang ? `?lang=${lang}` : ''}`, { withCredentials: true });
            setShareHolder(response.data);
        } catch (err) {
            console.log('Failed to fetch project details');
        }
    }
    const fetchArchData = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/services/slug/${id}${lang ? `?lang=${lang}` : ''}`, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.data) {
                setArchContent(response.data.data);
                setFeaturedProject(response.data.data.projects);
                // console.log('Facade content fetched:', response.data.data[0]);

            }
        } catch (err) {
            console.error('Error fetching home banner:', err);

        }
    };

    useEffect(() => {
        // fetchFeaturedProjectDetails();
        fetchArchData()
        fetchShareHolderDetails();
    }, [lang]);
    return (
        <Layout>
            <div className="shareholder-banner image-banner hero-banner color-light d-flex flex-column justify-end gap-30 d-gap-50 full-screen position-relative top-overlay bottom-overlay">
                <picture className="cover position-absolute top-0 start-0">
                    {/* <source media="(max-width:768px)" srcSet={heroMobileBanner} />
                    <img className="cover" src={heroDesktopBanner} alt="" /> */}
                    <HeroBanner filePath={`${config.BASE_URL}${archContent?.hero?.fileUrl}`} />

                </picture>
            </div>

            <div className="text-with-text-block shareholder-text banner-overlap pb-60 d-pb-150 position-relative z-2">
                <div className='container'>
                    <div className="grid-blocks d-grid align-end large-small gap-30 d-gap-50">
                        <div className="grid-block grid-left d-flex flex-column gap-20 d-gap-50">
                            <div className="summary-block">
                                <Link to="/"><img src={Logo} alt="Site Logo" /></Link>
                                <div className='title-block mt-20 mb-50'><h1>{archContent?.hero?.title}</h1></div>
                                <div className='text-block heading-font-family font-size-24 fw-400 mb-20'>{archContent?.hero?.subtitle}</div>
                                <p>{archContent?.hero?.paragraphs}</p>
                            </div>
                            <div className="grid-block d-grid d-column-2 gap-50">
                                <div className="text-block">
                                    <div className="number h2 mb-10">{archContent?.statistics?.ledStrips?.number}</div>
                                    <div className="text font-roboto-mono">{archContent?.statistics?.ledStrips?.description}</div>
                                </div>
                                <div className="text-block">
                                    <div className="number h2 mb-10">{archContent?.statistics?.retailSpace?.number}</div>
                                    <div className="text font-roboto-mono">{archContent?.statistics?.retailSpace?.description}</div>
                                </div>
                            </div>
                        </div>
                        <div className="grid-block grid-right">
                            <div className='grid-block'>
                                <ul>
                                    <li className='d-flex justify-end mb-10'><Link to='/about' className='button'>{content.navigation.aboutUs}</Link></li>
                                    <li className='d-flex justify-end'><Link to='/about#team' className='button'>{content.navigation.ourTeam}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Ourclient clients={shareholder[0]?.clients} />

            <div className='what-we-offer-section pt-60 d-pt-120 pb-60 d-pb-120'>
                <div className='container'>
                    <div className='section-heading pb-30 d-pb-60'>
                        <div className='h6'>{content.sections.whatWeOffer}</div>
                    </div>
                    <div className="offer-blocks d-grid d-column-2 gap-50 d-gap-70 d-row-gap-100">
                        {offers.map((item, index) => (
                            <div className="offer-block" key={index}>
                                <div className="offer-head d-flex align-center gap-20 d-gap-30">
                                    <div className="icon-box d-flex align-center justify-center">{item.icon}</div>
                                    <div className="title-block font-size-24 fw-200 d-mb-20">{item.title}</div>
                                </div>
                                <div className="summary-block pt-10 d-ps-80">{item.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='work-with-luminicos d-flex flex-column justify-end overlay position-relative pt-60 d-pt-120 pb-60 d-pb-120'>
                <picture className="cover position-absolute top-0 start-0">
                    <source media="(max-width:768px)" srcSet={expertiseMobileBanner} />
                    <img className="cover" src={expertiseDesktopBanner} alt="" />
                </picture>
                <div className='container position-relative z-2'>
                    <div className='section-heading mb-50'>
                        <div className='h6 mb-15'>{content.sections.unrivaledExpertise}</div>
                        <div className='h2'>{content.sections.whyWorkWith}</div>
                    </div>
                    <div className="work-blocks d-grid d-column-2 gap-50 d-gap-40 d-row-gap-30">
                        {reasons.map((title, index) => (
                            <div className="work-block d-flex align-center gap-20" key={index}>
                                <div className="icon-box d-flex align-center justify-center font-size-20">
                                    <FaCheck />
                                </div>
                                <div className="title-block font-size-24 fw-200 mb-0">{title}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='multicolumns pt-60 pb-40 d-pt-120 d-pb-60'>
                <div className='container'>
                    <div className='section-head d-ps-20 pb-30 d-pb-60'>
                        <div className='h6'>{content.sections.featuredProjects}</div>
                    </div>
                    <div className='grid-blocks d-grid d-column-2 gap-50'>

                        {featuredProject.map((hotel) => (
                            <div className="grid-block" key={hotel.id}>
                                <div className="image-block large-image h-0 position-relative">
                                    <img
                                        className="w-100 h-100 cover position-absolute top-0 start-0"
                                        src={`${config.BASE_URL}${hotel?.project?.featuredImage}`}
                                        alt={hotel?.project?.title}
                                    />
                                </div>
                                <div className="summary-block text-right px-15 pt-30 d-pt-50">
                                    <div className="text-block h6">
                                        {/* {hotel?.project?.location} */}
                                        {hotel?.project?.location ? hotel?.project?.location === 'undefined' ? '' : hotel?.project?.location : ''}

                                    </div>
                                    <h2 className="fw-300 mb-30">{hotel?.project?.title}</h2>
                                    <Link to={getProjectUrl(hotel?.project?.slug)} className="button gap-10">
                                        {content.buttons.viewMore} <CgArrowTopRight />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='porfolio-link-block d-pt-80 d-pb-60 border-bottom border-gray d-mb-50'>
                <picture className="cover top-overlay bottom-overlay position-absolute top-0 start-0">
                    {/* <source media="(max-width:768px)" srcSet={heroMobileBanner} />
                    <img className="cover" src={heroDesktopBanner} alt="" /> */}
                    <HeroBanner filePath={`${config.BASE_URL}${archContent?.hero?.fileUrl}`} />

                </picture>
                <div className='container'>
                    <div className='summary-block w-100 text-center'>
                        <div className='h1 mb-30 heading-font-family fw-200'>{content.portfolio.title}</div>
                        <Link to='/project_index' className='button border-bottom border-light px-5 pb-5'>{content.portfolio.button}</Link>

                    </div>
                </div>
            </div>

            <ClientReviews />
        </Layout>
    )
}

export default SingleService